import { PointCloudContentState } from '../state/point-cloud-content-state';

export function isRenderingWithRegionOfInterest(
  state: PointCloudContentState,
  currentOutputName: string,
) {
  const { regionOfInterestSettings, output } = state;
  return regionOfInterestSettings.enabled && currentOutputName === output.name;
}
